import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'weship-selected-standort';

export function useStandort() {
  const [standorte, setStandorte] = useState([]);
  const [standortId, setStandortIdState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? Number(stored) : null;
  });

  useEffect(() => {
    fetch('/api/standorte', { credentials: 'include' })
      .then(r => r.json())
      .then(list => {
        const arr = Array.isArray(list) ? list : [];
        setStandorte(arr);
        if (standortId && !arr.find(s => s.id === standortId)) {
          const first = arr[0]?.id || null;
          setStandortIdState(first);
          localStorage.setItem(STORAGE_KEY, first ? String(first) : '');
        }
        if (!standortId && arr.length > 0) {
          setStandortIdState(arr[0].id);
          localStorage.setItem(STORAGE_KEY, String(arr[0].id));
        }
      })
      .catch(() => {});
  }, []);

  const setStandortId = useCallback((id) => {
    const val = id === 'alle' || !id ? null : Number(id);
    setStandortIdState(val);
    localStorage.setItem(STORAGE_KEY, val ? String(val) : '');
  }, []);

  return { standorte, standortId, setStandortId };
}
